var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5804 5.78877C13.3055 4.59333 14.6022 3.86328 16.0004 3.86328C17.3985 3.86328 18.6952 4.59333 19.4204 5.78877L19.4242 5.7951L30.7175 24.6484L30.7283 24.6669C31.4391 25.8977 31.4433 27.4132 30.7395 28.6479C30.0357 29.8827 28.7295 30.6512 27.3083 30.6669L27.2937 30.667L4.69237 30.6669C3.27119 30.6513 1.96503 29.8827 1.26122 28.6479C0.557406 27.4132 0.561649 25.8977 1.27237 24.6669L1.2832 24.6484L12.5804 5.78877ZM14.862 7.16912L3.57726 26.0081C3.34476 26.4169 3.34482 26.9184 3.57796 27.3274C3.81155 27.7372 4.2442 27.9929 4.71555 28.0003H27.2852C27.7565 27.9929 28.1892 27.7372 28.4227 27.3274C28.6559 26.9184 28.6559 26.417 28.4235 26.0081L17.1404 7.17178L17.1387 7.16912C16.8967 6.77222 16.4654 6.52995 16.0004 6.52995C15.5353 6.52995 15.104 6.77222 14.862 7.16912Z",
    fill: "#D90022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0004 12.0003C16.7367 12.0003 17.3337 12.5972 17.3337 13.3336V18.6669C17.3337 19.4033 16.7367 20.0003 16.0004 20.0003C15.264 20.0003 14.667 19.4033 14.667 18.6669V13.3336C14.667 12.5972 15.264 12.0003 16.0004 12.0003Z",
    fill: "#D90022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 24.0003C17.3337 24.7367 16.7367 25.3336 16.0004 25.3336C15.264 25.3336 14.667 24.7367 14.667 24.0003C14.667 23.2639 15.264 22.6669 16.0004 22.6669C16.7367 22.6669 17.3337 23.2639 17.3337 24.0003Z",
    fill: "#D90022"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.026af041.svg";
export { ForwardRef as ReactComponent };